<template>
    <guest-layout :footer="false">
        <div class="set_center">
            <h5>Satu Akun Arkadia.me</h5>
            <h6 class="font-size">Untuk Beraktifitas Di semua layanan <a href="https://arkadiacorp.com/">Arkadia Corp</a></h6>
        </div>
        <loading-block v-if="loading" :message="message" />


        <div class="wrap-login" v-else>
            <h3 class="font-weight-bold text-uppercase">Login</h3>

            <div class="pull-left full"  v-if="errors.messages.errors">  
                <div class="alert alert-danger alert-dismissible">
                    {{ errors.messages.errors }}   
                </div>
            </div> 

            <form v-on:keyup.enter="handleSubmit">
                <div class="form-group" :class="errors.messages.username ? 'has-error' : ''">
                    <input type="text" v-model="form.username" class="form-control custom-input"  aria-describedby="emailHelp" placeholder="Username atau email">
                    <span class="help-block" v-if="errors.messages.hasOwnProperty('username')">
                        <strong>{{ errors.messages.username }}</strong>
                    </span> 
                </div>
                <!-- <div class="form-group" :class="errors.messages.password ? 'has-error' : ''">
                    <input type="password" v-model="form.password" class="form-control custom-input" placeholder="Password" >
                    <span class="help-block" v-if="errors.messages.hasOwnProperty('password')">
                        <strong>{{ errors.messages.password }}</strong>
                    </span>
                </div> -->

                <div class="form-group" :class="errors.messages.password ? 'has-error' : ''" style="position:relative;">
                  <input 
                    :type="showPassword ? 'text' : 'password'" 
                    v-model="form.password" 
                    class="form-control custom-input" 
                    placeholder="Password" 
                    style="padding-right:40px;"
                  >
                  <!-- icon eye -->
                  <i 
                    :class="['fa', showPassword ? 'fa-eye-slash' : 'fa-eye']" 
                    @click="showPassword = !showPassword"
                    style="position:absolute; right:10px; top:50%; transform:translateY(-50%); cursor:pointer; color:#666;"
                  ></i>
                  
                  <span class="help-block" v-if="errors.messages.hasOwnProperty('password')">
                    <strong>{{ errors.messages.password }}</strong>
                  </span>
                </div>

                <div class="row mb-3">
                    <div class="col-6">
                    </div>
                    <div class="col-6 text-right">
                        <router-link :to="{ name: 'lost-password', query: { popup: true }}" class="font-weight-bold text-dark">Lupa Password</router-link>
                    </div>
                </div>
            </form>
            <div class="recaptcha-wrap" v-if="failed >= 3">
                <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                <span>Wajib diisi</span>
            </div>
            <button class="btn btn-primary main-button login-button" @click="handleSubmit" :disabled="form.recaptcha === '' && failed >= 3">Login</button>
            <hr/>
            <div class="row">
                <!-- <div class="col-6 margin-bottom-20">
                    <button class="btn btn-primary main-button facebook-login" @click="handleFacebook">
                        <i class="bi bi-facebook"></i> <span class="ml-1">Daftar/Masuk</span>
                    </button>
                </div> -->
                <div class="col-6">
                    <button class="btn btn-primary main-button google-login" @click="handleGoogle">
                        <i class="bi bi-google"></i> <span class="ml-1">Daftar/Masuk</span>
                    </button>
                </div>
            </div>
            <br/>
            <div class="text-center mt-3">
                <p>Belum memiliki akun ? <br>

                   
                       <router-link   :to="{path: '/register?ref='+ tag }" class="font-weight-bold text-dark" >Daftar Akun</router-link>

                 

                </p>
            </div>
        </div>
    </guest-layout>
</template>

<script>

import axios from 'axios';
import VueRecaptcha from 'vue-recaptcha';
import {loadScript} from '../Sso'

export default {
    components: { VueRecaptcha },
    data() {
        return {
            errors: {
                messages: {
                    username:'',
                    password:'',
                    recaptcha:'',
                    errors:'',       
                },
            },
            failed: 0,
            showPassword: false, // untuk toggle eye
            form: {
                _token:'',
                username: '',
                password: '',
                recaptcha: ''
            },
            recaptcha: true,
            loading: true,
            message: '',
            tag:'',
        }
    },
    async mounted () {
        const urlParams = new URLSearchParams(window.location.search);
        this.tag = urlParams.get("ref");
        
        if(this.$route.query.credential) {
            await this.oneTap()
        } else {
            await this.getCallback()
        }
       await this.loadFacebook()
         
         
    },
    methods: {
         
        async oneTap() {

            this.loading = true;
            this.message = 'Sedang Login...';
         
            await axios.post('/login-onetap?ref='+ this.tag, {credential: this.$route.query.credential})
                .then(async(response) => {
                    //
                    this.$cookies.set('token', response.data.token, null, null, null,true, 'None');
                    this.$cookies.set('shared_token', response.data.token, null, null, '.arkadia.me', true, 'None');
                    this.$cookies.set('sso_data', response.data.sso_data, null, null, null, true, 'None');
                     const token = response.data.token;
                     const sso_data = response.data.sso_data;
                     const user = response.data.user;
                   

                    // Handle login sso
                   // this.handleSso(response.data.url,false);
                    this.message = '';
                    window.top.postMessage({ success: 1, token: token,sso_data:sso_data,user:user }, '*');
                    window.opener = self;
                    window.close();

                  


                })
                .catch((error) => {
                    //this.loading = false;
                    
                });
        },
        async getCallback(){
            const token = this.$cookies.get('token');
            this.message = 'Memeriksa status...'
            if(token) {
                await axios.get('/info/user')
                    .then(async(response) => {
                        // Handle login sso
                        this.$cookies.set('token', response.data.token, null, null, null, true);
                        this.$cookies.set('shared_token', response.data.token, null, null, '.arkadia.me', true, 'None');
                        
                        this.$cookies.set('sso_data', response.data.sso_data, null, null, null, true, 'None');
                        // this.loading = false
                        const token = response.data.token;
                        const sso_data = response.data.sso_data;
                        const user = response.data.user;
                        window.top.postMessage({ success: 1, token: token,sso_data:sso_data,user:user }, '*');
                        this.message = 'Terima kasih, proses login aktif.';
                        window.opener = self;
                        window.close();
                    })
                    .catch((error) => {
                        this.loading = false
                    });
            } else {
                this.loading = false
            }
        },
        async handleSubmit(event) {
            this.loading = true;
            this.message = 'Sedang Login...';
           
            // this.errors = [];
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            this.form._token = csrfToken;
            await axios.post('/login?ref='+ this.tag, this.form)
            .then(async (response) => {
                //
                this.$cookies.set('token', response.data.token, null, null, null,true, 'None');
                this.$cookies.set('shared_token', response.data.token, null, null, '.arkadia.me', true, 'None');
                this.$cookies.set('sso_data', response.data.sso_data);
                const token = response.data.token;
                const sso_data = response.data.sso_data;
                const user = response.data.user;
                // Handle login sso
                
                // this.$cookies.set('token',response.data.token);
                // this.$cookies.set('shared_token', response.data.token);
                // this.$cookies.set('sso_data', response.data.sso_data);
              //  await this.handleSso(response.data.url);
                this.message = 'Terima kasih, proses login aktif.';
                window.top.postMessage({ success: 1, token: token,sso_data:sso_data,user:user }, '*');
                window.opener = self;
                window.close();
            })
            .catch((error) => {
                this.loading = false;
                if(this.failed >= 3) {
                    this.$refs.recaptcha.reset();
                }
                if(error.response) {
                    this.recaptcha = true
                    if(error.response.status === 422) {
                        this.errors = error.response.data.errors
                        if(error.response.data.errors.hasOwnProperty('recaptcha')) {
                            this.failed = 3;
                        }
                    } else if (error.response.status === 401) {
                        this.failed++;
                    }
                    this.errors = error.response.data;
                    if(this.errors.messages.errors)
                    {
                       setTimeout(() => {
                            this.errors =  {
                                messages: {
                                    username:'',
                                    password:'',
                                    recaptcha:'',
                                    errors:'',
                                },
                            };

                        } , 10000);

                    } 



                }
            });
        },
        async handleGoogle () {
            const googleUser = await this.$gAuth.signIn()
            if(googleUser) {
                const auth = googleUser.getAuthResponse()
                const status = await this.sendToApiSocial(auth.access_token, 'google')
                if(status) {
                    await this.$gAuth.signOut();
                }
            }
        },
        async sendToApiSocial (token, type) {
            this.loading = true;
            this.message = 'Sedang Login...'
            axios.post('/login-social?ref='+ this.tag, {type: type, token: token})
            .then(async (response) => {
                 
                 //Handle login sso
                this.$cookies.set('token', response.data.token, null, null, null,true, 'None');
                this.$cookies.set('shared_token', response.data.token, null, null, '.arkadia.me', true, 'None');
                const token = response.data.token;
                const sso_data = response.data.sso_data;
                const user = response.data.user;
                this.$cookies.set('token',response.data.token);
                this.$cookies.set('shared_token', response.data.token);
                this.$cookies.set('sso_data', response.data.sso_data);
                // Handle login sso
                //await this.handleSso(response.data.url);

                setTimeout(function(){
                        this.message = '';
                        window.top.postMessage({ success: 1, token: token,sso_data:sso_data,user:user }, '*');
                        window.opener = self;
                        window.close();
                    }, 1000);
               
                
            })
            .catch((error) => {
                
                this.errors = error.response.data;
                if(this.errors.messages.errors)
                {
                   setTimeout(() => {
                        this.errors =  {
                            messages: {
                                username:'',
                                password:'',
                                recaptcha:'',
                                errors:'',
                            },
                        };

                    } , 10000);

                } 

                this.loading = false;
                return false;
            });
        },
        async handleFacebook() {
            window.FB.login(async (response) => {
                if (response.authResponse) {
                    const status = await this.sendToApiSocial(response.authResponse.accessToken, 'facebook')
                    if(status) {
                        this.handleFacebookLogout()
                    }
                }
            }, {scope: 'email,public_profile'});
            return false;
        },
        async handleFacebookLogout() {
            window.FB.logout(async (response) => {
                if (response) {
                    // Handle response
                }
            });
        },
        async loadFacebook() {
            await this.loadFacebookSDK(document, "script", "facebook-jssdk");
            await this.initFacebook();
        },
        async initFacebook() {
            window.fbAsyncInit = function() {
                window.FB.init({
                    appId: "2356297901305750",
                    cookie: true,
                    version: "v15.0"
                });
            };
        },
        async loadFacebookSDK(d, s, id) {
            var js,
                fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        async handleSso(url) {
            url.forEach(async (item) => {
                await $.getScript(item.url.toString())
                    .done(( script, textStatus ) => {
                        // totalRun = totalRun +1
                        // console.log(textStatus)
                    })
                    .fail(( jqxhr, settings, exception ) => {
                        // totalRun = totalRun +1
                        console.log('error',exception)
                    });
            });
        }
    }
}
</script>
<style scoped>
.set_center{
  margin: 13px 0px;
  text-align: left;
  padding: 0px 7px;
}
.guest-layout {

    min-height: 80vh!important;



}
.google-login img {
    border-right: 1px solid #fff;
    padding-right: 5px;
    margin-right: 5px;
}
.facebook-login {
    align-items: center;
}
.facebook-login img {
    border-right: 1px solid #fff;
    padding-right: 5px;
    margin-right: 5px;
}
.wrap-login {
    padding: 1%;
    margin-top: 15px;
}
.recaptcha-wrap {
    margin-bottom: 10px;
    border-radius: 6px;
    padding-top: 5px;
}
.recaptcha-wrap span {
    display: none;
}
.recaptcha-wrap.error {
    border: 1px solid #d82020;
    text-align: center;
}
.recaptcha-wrap.error span {
    color: #d82020;
    font-size: 12px;
    display: block;
}
.recaptcha-wrap div {
    margin: 0 auto;
    display: block;
}

.font-size{
    font-size: 14px;
}
.col-6 {
    flex: none!important;
    max-width: none!important;
}

.margin-bottom-20{
    margin-bottom:20px;
}
</style>
